export default __webpack_public_path__ + "static/media/c.f1e4a93d.svg";